module.exports = __webpack_public_path__ + "media/src/img/about-cloud-rh-ef0c4ed95b8b5c0a252ebdd8079420ce.png";